import { clientHomeData, clientPageData, PortfolioComponent } from '../../type/client-index'
import { IndexImage, IpadIphone, Reel1, Reel2, Reel3 } from './assets'

export const home: clientHomeData = {
  slug: 'room-260',
  name: 'Room 260',
  types: ['création de contenu'],
  image: IndexImage
}

const detailed: clientPageData = {
  seo: {
    // Le titre est généré comme ça: {name} - Atelier Milky
    title: 'Room 260',
    description: 'Découvrez notre travail avec Room 260.'
  },
  blocks: [
    {
      id: 1,
      componentName: PortfolioComponent.presentationSlide,
      props: {
        title: home.name,
        types: home.types,
        images: [IpadIphone],
        urls: { website: 'https://room-260.com/', instagram: 'https://www.instagram.com/room260shop/' },
        subtitle: 'La marque',
        variant: 1,
        description: {
          cols: 2,
          content: [
            "Situé à Waterloo, Room 260 est un magasin de prêt-à-porter s'adressant aux couples. Vous pourrez y retrouver de nombreuses marques sélectionnées avec soin par Edna et Raphaël.",
            'Ce duo de passionnés accompagnent leur client avec une belle énergie et partagent sans hésiter leurs conseils hyper personnalisés.'
          ]
        }
      }
    },
    {
      id: 2,
      componentName: PortfolioComponent.fullHeightVideos,
      props: {
        title: 'Notre travail',
        description: {
          cols: 2,
          content: [
            'Afin de ne jamais perdre le rythme, Room260 a décidé de travailler tous les mois avec Atelier Milky.',
            "Au programme ? Le tournage de reels suivi d'un shooting photo des tenues. Après plus d'un an de collaboration et de conseils, Room a vu la qualité de son compte ainsi que sa communauté évoluer au fil des mois."
          ]
        },
        variant: 2,
        videosCfIds: [Reel1, Reel2, Reel3]
      }
    }
  ]
}

export default detailed
